import React from "react";
import { Container } from "@mui/material";
import BillingBreadcrumb from "../components/BillingBreadcrumb";
import CheckoutForm from "../components/CheckoutForm";

const Checkout = () => {
  return (
    <>
      <div className="bg-grey" style={{ marginBottom: "70px", backgroundColor: '#f7f5f5',  borderRadius: "4px",padding:'20px 20px 50px' }} >
        <Container >
        <BillingBreadcrumb />
        <CheckoutForm />
      </Container>
    </div >
    </>
    
  
  );
};

export default Checkout;
